import axios from "../../interceptor/ApiInterceptor";
import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import authActions from "../../redux/actions/auth";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export const useAppoDetList = () => {
  const dispatch = useDispatch();
  const [errorState, setErrorState] = useState({ error: false, errorMessage: "" });
  const [auditoriasDetalle, setAuditoriasDetalle] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const params = useParams();
  const tx = params.tx;
  const user = useSelector(state => state.auth.user)
  const numeroDoc = user?.idNumber

  const { REACT_APP_JAVA_BE_URL } = process.env;

  const SearchAuditoriaDetalle = useCallback(() => {
    const url = `${REACT_APP_JAVA_BE_URL}/external/api/v1/faba/practicesByTransaction`;
    const payload = { tx, numeroDoc };

    setIsSearching(true);

    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.ok) {
          setAuditoriasDetalle(res.data.data);


          setErrorState({ error: false, errorMessage: "" });
        } else {
          setAuditoriasDetalle([]);
          setErrorState({ error: true, errorMessage: res.data.error || "Error en la respuesta del servidor." });
        }
      })
      .catch((error) => {
        console.error("Error al obtener auditoría:", error);
        let message = "Error al obtener los datos.";

        if (error.response) {
          const { status, data } = error.response;

          if (status === 504) {
            message = "En este momento no podemos acceder al detalle. Vuelva a intentar en unos minutos.";
          } else if (status === 401) {
            dispatch(authActions.signOut(true));
            message = "Sesión expirada. Por favor, inicie sesión nuevamente.";
          } else {
            message = data?.error || message;
          }
        }

        setErrorState({ error: true, errorMessage: message });
        setAuditoriasDetalle([]);
      })
      .finally(() => {
        setIsSearching(false);
      });
  }, [REACT_APP_JAVA_BE_URL, tx, dispatch,numeroDoc]);

  useEffect(() => {
    if (tx &&  numeroDoc) SearchAuditoriaDetalle();
  }, [SearchAuditoriaDetalle, tx,numeroDoc]);

  return {
    auditoriasDetalle,
    errorState,
    isSearching,
    tx,
    numeroDoc
  };
};
